var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item dark"},[_c('h2',{staticClass:"heading"},[_vm._v("Your shipping and contact details")]),_c('p',{staticClass:"text"},[_vm._v("The following details will not be included on the cards, but will be used to contact you and ship the cards")]),_c('span',{staticClass:"small-text"},[_vm._v("3 Questions")])])
}]

export { render, staticRenderFns }